import React, { memo, useState } from "react";
import { fetchHotKinds } from "../../services/article_v2";
import { host } from "@Services/url";
import { IHotKinds } from "@Types/articles";
import { useMount } from "ahooks";

const SellingCar: React.FC<{ isInSummary?: boolean; source: string }> = ({ isInSummary, source }) => {
  const limit = 10;
  const [hotKinds, setHotKinds] = useState<IHotKinds[]>([]);

  const getHotKinds = async () => {
    const res = await fetchHotKinds({ limit });
    if (res.status === 12000) {
      setHotKinds(res.data?.list || []);
    }
  };

  useMount(() => {
    getHotKinds();
  });

  return (
    <div className='flex justify-between flex-wrap min-h-[500px]'>
      {hotKinds?.map((item) => (
        <div
          className='flex flex-col w-120 justify-center items-center mb-24 cursor-pointer'
          onClick={() => {
            if (isInSummary) {
              window.open(`${host.c}/ask/price?b=${item.brandId}&k=${item.kindId}`, "_blank");
              return;
            }
            window.open(`${host.c}/photoModel-info.html?k=${item.kindId}`, "_blank");
          }}
          key={item.kindId}
        >
          <img width={120} height={80} src={item.thumb} alt={item.kindName} loading="lazy" style={{ aspectRatio: "120/80" }}/>
          <div className='w-130 h-22 leading-22 text-ellipsis overflow-hidden text-16 text-[#333] font-normal text-center'>
            {item.brandName} {item.kindName}
          </div>
          <div className='mt-4 text-14 text-[#ff0000] font-normal text-center'>{item.price}</div>
          <a
            href={`/ask/price?b=${item.brandId}&k=${item.kindId}&source=${source}`}
            target='_blank'
            onClick={(e) => {
              e.stopPropagation();
            }}
            className='w-84 h-30 leading-30 text-center mt-8 border-solid rounded-6 border-[#ff3232] border-1 text-12 font-normal text-[#ff3232] cursor-pointer hover:text-[#ff3232]'
          >
            一鍵詢價
          </a>
        </div>
      ))}
    </div>
  );
};

export default memo(SellingCar);
